<template>
  <div id="mythVsFactTwo"></div>
</template>

<script>
export default {
  name: "MythVsFactTwo",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        myth: "You need to post every day to grow on LinkedIn",
        fact: "Consistency matters more than frequency. 3 quality posts per week beats 7 rushed ones.",
        chip: "Myth Busted",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("mythVsFactTwo");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const labelSize = exporting ? 22 : 22 * this.scale;
      const textSize = exporting ? 32 : 32 * this.scale;
      const logoHeight = exporting ? 40 : 40 * this.scale;
      const chipSize = exporting ? 20 : 20 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.light || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#10a37f";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background: linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 25%, #16213e 50%, #1a1a2e 75%, #0f0f0f 100%);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Gradient orb effect -->
          <div style="
            position: absolute;
            top: -20%;
            right: -20%;
            width: 60%;
            height: 60%;
            background: radial-gradient(circle, #ef444425 0%, transparent 70%);
            pointer-events: none;
          "></div>
          <div style="
            position: absolute;
            bottom: -30%;
            left: -20%;
            width: 70%;
            height: 70%;
            background: radial-gradient(circle, ${primaryColor}30 0%, transparent 60%);
            pointer-events: none;
          "></div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" style="opacity: 0.9;" />
          </div>

          <!-- Content -->
          <div style="padding: 0 8%; position: relative; z-index: 1; flex: 1; display: flex; flex-direction: column; justify-content: center;">
            <!-- Myth -->
            <div style="
              background: rgba(239, 68, 68, 0.1);
              border: 1px solid rgba(239, 68, 68, 0.3);
              border-radius: 16px;
              padding: 24px;
              margin-bottom: 24px;
            ">
              <div style="
                font-size: ${labelSize}px;
                font-weight: 700;
                color: #ef4444;
                text-transform: uppercase;
                letter-spacing: 0.1em;
                margin-bottom: 12px;
              ">❌ MYTH</div>
              <div style="
                font-size: ${textSize}px;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.6);
                line-height: 1.4;
                text-decoration: line-through;
              ">${this.data.myth}</div>
            </div>

            <!-- Fact -->
            <div style="
              background: rgba(16, 163, 127, 0.1);
              border: 1px solid rgba(16, 163, 127, 0.3);
              border-radius: 16px;
              padding: 24px;
            ">
              <div style="
                font-size: ${labelSize}px;
                font-weight: 700;
                color: ${primaryColor};
                text-transform: uppercase;
                letter-spacing: 0.1em;
                margin-bottom: 12px;
              ">✅ FACT</div>
              <div style="
                font-size: ${textSize}px;
                font-weight: 500;
                color: #ffffff;
                line-height: 1.4;
              ">${this.data.fact}</div>
            </div>
          </div>

          <!-- Footer with chip -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <div style="display: flex; justify-content: center;">
              <span
                style="
                  display: inline-block;
                  background: rgba(255, 255, 255, 0.1);
                  backdrop-filter: blur(10px);
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 10px 24px;
                  letter-spacing: 0.05em;
                  text-transform: uppercase;
                  border: 1px solid rgba(255, 255, 255, 0.15);
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped></style>
